import React from "react"
const MailIcon = ({ size, className }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 26 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g id="mail-02">
				<path
					id="Icon"
					d="M23.2929 19.4997L16.0965 12.9997M9.90606 12.9997L2.70967 19.4997M2.16797 7.58301L11.0133 13.7747C11.7296 14.2761 12.0877 14.5268 12.4773 14.6239C12.8214 14.7097 13.1812 14.7097 13.5253 14.6239C13.9149 14.5268 14.273 14.2761 14.9893 13.7747L23.8346 7.58301M7.36797 21.6663H18.6346C20.4548 21.6663 21.3649 21.6663 22.0601 21.3121C22.6716 21.0005 23.1688 20.5033 23.4804 19.8918C23.8346 19.1966 23.8346 18.2865 23.8346 16.4663V9.53301C23.8346 7.71284 23.8346 6.80275 23.4804 6.10754C23.1688 5.49601 22.6716 4.99883 22.0601 4.68724C21.3649 4.33301 20.4548 4.33301 18.6346 4.33301H7.36797C5.5478 4.33301 4.63771 4.33301 3.9425 4.68724C3.33097 4.99883 2.83379 5.49601 2.5222 6.10754C2.16797 6.80275 2.16797 7.71284 2.16797 9.53301V16.4663C2.16797 18.2865 2.16797 19.1966 2.5222 19.8918C2.83379 20.5033 3.33097 21.0005 3.9425 21.3121C4.63771 21.6663 5.5478 21.6663 7.36797 21.6663Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	)
}
export default MailIcon
